import { LeaveTypeCode } from "../models/leaveModels";

/** Stable color per leave type — used by the calendar and legends. */
export const LEAVE_TYPE_COLORS: Record<LeaveTypeCode, string> = {
  VL: "#0f6cbd", // blue
  SL: "#c50f1f", // red
  BL: "#8764b8", // purple
  EL: "#ca5010", // orange
  ML: "#e3008c", // magenta
  PL: "#0e7a0b", // green
  SPL: "#008272", // teal
  MC: "#986f0b", // gold
  LWOP: "#616161", // grey
};

export function leaveTypeColor(code?: LeaveTypeCode): string {
  return (code && LEAVE_TYPE_COLORS[code]) || "#616161";
}
